// Typelizer digest 271740ec29f87895f857df35efcf3705
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/timetable */
  show: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/timetable', params, options),
    method: 'get',
  }),

  /** PATCH /educators/teachers/:teacher_id/timetable */
  update: (
    params: { teacherId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/timetable', params, options),
    method: 'patch',
  }),
}
